<template>
  <v-app>
    <v-container>
      <dailyUpdateSetup
        v-model:dialog="dialog"
        :data="data"
        @update:dialog="dialog = $event"
        @update-success="reloadLeadData"
      />
      <assignEmployeeSetup
        v-model:dialog="assignDialog"
        :data="data"
        @update:dialog="assignDialog = $event"
        @update-success="reloadLeadData"
      />
      <div>
        <!-- Lead Header -->
        <div v-if="Object.keys(leadView).length > 0" class="mb-6">
          <v-card class="px-4 py-1 bg-primary text-white">
            <v-row align="center">
              <v-col cols="12" md="6">
                <div>
                  <h2 class="p-4 text-body-4 "> <v-icon>
                    mdi-lead-pencil
                  </v-icon> Lead Info</h2>
                </div>
                <div class="d-flex align-center gap-4 ">
                  <p><strong>Company Name:</strong> {{ leadView.company_name }} 
                  
                </p>
                <p>
                  <strong>Created Date:</strong> {{ leadView.lead_date }}
                </p>
                </div>
              </v-col>
              <v-col cols="12" md="6" class="text-md-right text-center">
                <v-chip class="pa-4 text-body-1 text-blue-darken-1 bg-white">
                  {{ leadView.lead_status?.name || "Active" }}
                </v-chip>
              </v-col>
            </v-row>
          </v-card>
        </div>

        <div v-else-if="isLoading" class="text-center my-6">
          <v-progress-circular
            indeterminate
            color="deep-purple"
          ></v-progress-circular>
        </div>

        <div v-else class="text-center text-grey my-6">
          <p>No lead data found</p>
        </div>

        <div class="d-flex justify-end mb-6 mx-4" v-if="tab !== 1">
          <v-btn
            color="primary"
            variant="tonal"
            prepend-icon="mdi mdi-plus"
            rounded="xl"
            @click="openModal(leadView)"
          >
            {{ addButtonText }}
          </v-btn>
        </div>

        <!-- Tabs -->
        <v-card class="elevation-2">
          <v-tabs v-model="tab" align-tabs="center" color="primary">
            <v-tab :value="1">Profile</v-tab>
            <v-tab :value="2">Activity Log</v-tab>
            <v-tab :value="3">Assigned</v-tab>
          </v-tabs>

          <v-divider></v-divider>

          <v-tabs-window v-model="tab">
            <!-- Profile Tab -->
            <v-tabs-window-item :value="1">
              <v-container fluid>
                <v-row dense>
                  <v-col cols="12" md="4">
                    <div class="pa-4">
                      <v-card-title class="text-h6 font-weight-bold">
                        <v-icon left>mdi-domain</v-icon> Company Information
                      </v-card-title>
                      <v-card-text>
                        <p>
                          <strong>Company:</strong> {{ leadView.company_name }}
                        </p>
                        <p>
                          <strong>Email:</strong> {{ leadView.company_email }}
                        </p>
                        <p>
                          <strong>Phone:</strong> {{ leadView.company_phone }}
                        </p>
                      </v-card-text>
                    </div>
                  </v-col>

                  <v-col cols="12" md="4">
                    <div class="pa-4">
                      <v-card-title class="text-h6 font-weight-bold">
                        <v-icon left>mdi-account-tie</v-icon> Contact
                        Information
                      </v-card-title>
                      <v-card-text>
                        <p>
                          <strong>Name:</strong> {{ leadView.contact_name }}
                        </p>
                        <p>
                          <strong>Designation:</strong>
                          {{ leadView.contact_designation }}
                        </p>
                        <p>
                          <strong>Email:</strong> {{ leadView.contact_email }}
                        </p>
                        <p>
                          <strong>Phone:</strong> {{ leadView.contact_number }}
                        </p>
                      </v-card-text>
                    </div>
                  </v-col>

                  <v-col cols="12" md="4">
                    <div class="pa-4">
                      <v-card-title class="text-h6 font-weight-bold">
                        <v-icon left>mdi-lightbulb-on-outline</v-icon> Lead
                        Information
                      </v-card-title>
                      <v-card-text>
                        <p><strong>Code:</strong> {{ leadView.code }}</p>
                        
                        <p>
                          <strong>Source:</strong>
                          {{ leadView.lead_source_type?.name }}
                        </p>
                      </v-card-text>
                    </div>
                  </v-col>
                </v-row>
              </v-container>
            </v-tabs-window-item>

            <!-- Activity Log Tab -->
            <v-tabs-window-item :value="2">
              <v-container fluid>
                <v-card class="pa-4 elevation-1">
                  <v-card-title class="text-h6 font-weight-bold text-primary">
                    <v-icon left>mdi-history</v-icon> Activity Log
                  </v-card-title>
                  <v-divider></v-divider>
                  <v-card-text>
                    <v-timeline
                      v-for="(activity, index) in leadActivity"
                      :key="index"
                      align="center"
                      density="compact"
                    >
                      <v-timeline-item size="small" color="deep-purple">
                        <v-card class="pa-3 w-100" flat>
                          <div class="d-flex align-center">
                            <v-avatar
                              icon="$vuetify"
                              :image="
                                getFileServerUrl +
                                (activity.created_by.image_thumb != null
                                  ? activity.created_by.image_thumb
                                  : 'uploads/demo_images/user.png')
                              "
                              size="40"
                            ></v-avatar>
                            <v-col>
                              <h3>{{ activity.created_by.full_name }}</h3>
                              <p>
                                {{ activity.follow_up_date }}
                              </p>
                            </v-col>
                          </div>
                          <p class="synopsis-text">
                            <strong>Synopsis details:</strong>
                            {{ activity.synopsis_details }}
                          </p>
                          <v-row class="pa-3 align-center">
                            <p><strong>Status:</strong></p>
                            <v-col class="d-flex ga-1">

                              <v-chip
                                class="bg-yellow-lighten-1 text-yellow-darken-4 font-weight-bold"
                                >{{ activity.lead_status.name }}</v-chip
                              >
                              
                            </v-col>
                          </v-row>
                          <v-divider></v-divider>
                          <p class="mt-2">
                            <strong>Next follow-up date:</strong>
                            {{ activity.next_follow_up_date }}
                          </p>
                        </v-card>
                      </v-timeline-item>
                    </v-timeline>
                  </v-card-text>
                </v-card>
              </v-container>
            </v-tabs-window-item>

            <!-- Assigned Tab -->
            <v-tabs-window-item :value="3">
              <v-container fluid>
                <v-row>
                  <v-col
                    v-for="(employee, index) in leadAssigned"
                    :key="index"
                    cols="12"
                    md="4"
                  >
                    <v-card class="pa-0 position-relative">
                      <v-card-text class="pa-2">
                        <v-checkbox
                          single-line
                          hide-details
                          density="compact"
                          color="indigo"
                          class="checkbox-position"
                        ></v-checkbox>
                        <v-row>
                          <v-col cols="12" md="4">
                            <v-avatar
                              icon="$vuetify"
                              :image="
                                getFileServerUrl +
                                (employee.employee.imageThumb != null
                                  ? employee.employee.imageThumb
                                  : 'uploads/demo_images/user.png')
                              "
                              size="100"
                              class="rounded-0"
                            ></v-avatar>
                          </v-col>
                          <v-col cols="12" md="8">
                            <p class="my-1 d-flex">
                              <v-icon>mdi-account</v-icon>
                              <span class="ml-2 d-inline-block">{{
                                employee.employee.name
                              }}</span>
                            </p>
                            <p class="my-1 d-flex">
                              <v-icon>mdi-school-outline</v-icon>
                              <span class="ml-2 d-inline-block">{{
                                employee.employee.designation.name
                              }}</span>
                            </p>
                            <p class="my-1 d-flex">
                              <v-icon>mdi-home-group</v-icon>
                              <span class="ml-2 d-inline-block">{{
                                employee.employee.department.name
                              }}</span>
                            </p>
                          </v-col>
                        </v-row>
                      </v-card-text>
                    </v-card>
                  </v-col>
                </v-row>
              </v-container>
            </v-tabs-window-item>
          </v-tabs-window>
        </v-card>
      </div>
    </v-container>
  </v-app>
</template>

<script>
import dailyUpdateSetup from "@/components/module/sales/lead/dailyUpdateSetup.vue";
import assignEmployeeSetup from "@/components/module/sales/lead/assignEmployeeSetup.vue";
export default {
  components: {
    dailyUpdateSetup,
    assignEmployeeSetup,
  },
  name: "LeadView",
  data() {
    return {
      id: "",
      tab: 1,
      addButtonText: "",
      dialog: false,
      assignDialog: false,
      data: {},
      leadView: {},
      leadActivity: [],
      leadAssigned: [],
      isLoading: false,
    };
  },
  computed: {
    getFileServerUrl() {
      return this.$store.getters.getFileServerUrl;
    },
  },
  methods: {
    openModal(data) {
      this.data = { ...data };
      if (this.tab === 2) {
        this.dialog = true;
      } else if (this.tab === 3) {
        this.assignDialog = true; 
      }
    },
    reloadLeadData() {
      if (this.id) {
        this.isLoading = true;
        this.$store.dispatch("getSalesLeadsById", this.id).then((response) => {
          this.leadView = response.data;
          this.isLoading = false;
        });
      }
    },
  },
  watch: {
    tab(val) {
      if (val === 3) {
        this.addButtonText = "New Assign";
        this.leadAssigned = this.leadView.lead_assigned || [];
      } else if (val === 2) {
        this.addButtonText = "Add Daily Update";
        this.leadActivity = this.leadView.lead_details || [];
      }
    },
    leadView(val, oldval) {
      this.leadActivity = val.lead_details || [];
      this.leadAssigned = val.lead_assigned || [];
    },
  },
  created() {
    this.leadView = {};
    this.leadAssigned = [];
    this.leadActivity = [];
  },
  mounted() {
    const id = this.$route.params.id || "";
    console.log(id);
    if (id) {
      this.id = id;
      this.isLoading = true;
      this.$store.dispatch("getSalesLeadsById", id).then((response) => {
        this.leadView = response.data;
        this.isLoading = false;
      });
    } else {
      this.leadView = this.$store.getters.getViewingSalesLeads;
      this.leadActivity = this.leadView?.lead_details || [];
      this.leadAssigned = this.leadView?.lead_assigned || [];
    }
  },
};
</script>

<style scoped>
.w-100 {
  width: 100% !important;
}

.position-relative {
  position: relative;
}

.checkbox-position {
  position: absolute;
  top: 8px;
  right: 8px;
  z-index: 1;
}

.synopsis-text {
  white-space: normal;
  word-wrap: break-word;
  overflow-wrap: anywhere;
}
</style>
